
import { mapGetters } from 'vuex'
export default {
  name: "TabsContainer",
  props: {
    id: {
      default: 'default',
      type: String,
    },
    active: {
      default: '',
      type: String,
    },
    hidden: {
      default: '',
      type: String,
    }
  },
  computed: {
    ...mapGetters({
      activeClassroomTab : 'pages/getActiveClassroomTab' || this.id,
    }),
    startHidden() {
      // console.log('TABS HIDDEN?: ',this.hidden);
      // console.log('TABS ACTIVE?: ',this.active);
      // console.log('ACTIVE TAB?: ',this.activeClassroomTab);
      return this.hidden !== '' && this.activeClassroomTab === null
    }
  },
  render() {
    const slot = this.$slots.default
    //  return slot.text.replace(/,/g, "")
    return slot
  },
}
